import { Grid2 as Grid, FormControlLabel, Switch } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Copia } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikDatePicker, FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import { ACFormato, ACLuogo } from "./autocompletes"

export default function CopiaForm({ item, save, ref }: FormInDialogProps<Copia>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return item ?? {
      data: undefined,
      uscita: undefined,
      rientro: undefined,
      lab: "",
      esterna: false,
      intervento: "",
      note: "",
      luogo: null,
      formato: null,
    }
  }, [item])

  const schema = useMemo(() => yup.object().shape({}), [t])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Copia).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={6}>
                <Field
                  component={FormikDatePicker}
                  name="data"
                  label={t("general.data")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={6}>
                <FormControlLabel
                  control={
                    <Switch checked={values.esterna} onChange={(e) => setFieldValue("esterna", e.target.checked)} />
                  }
                  label={t("copia.esterna")}
                />
              </Grid>
              <Grid size={8}>
                <Field
                  name="lab"
                  label={t("copia.lab")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>

              <Grid size={4}>
                <ACLuogo
                  margin="dense"
                  variant="outlined"
                  label={t("general.luogo")}
                  value={values.luogo ? values.luogo : undefined}
                  onChange={(value) => {
                    setFieldValue("luogo", value)
                  }}
                />
              </Grid>

              <Grid size={6}>
                <Field
                  component={FormikDatePicker}
                  name="uscita"
                  label={t("copia.uscita")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid size={6}>
                <Field
                  component={FormikDatePicker}
                  name="rientro"
                  label={t("copia.rientro")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>

              <Grid size={4}>
                <ACFormato
                  margin="dense"
                  variant="outlined"
                  label={t("general.formato")}
                  value={values.formato ? values.formato : undefined}
                  onChange={(value) => {
                    setFieldValue("formato", value)
                  }}
                />
              </Grid>

              <Grid size={12}>
                <Field
                  name="intervento"
                  label={t("copia.intervento")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={6}
                />
              </Grid>

              <Grid size={12}>
                <Field
                  name="note"
                  label={t("general.note")}
                  component={FormikTextField}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={6}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
